import { addErrors, clearCursorWait, clearErrors, setCursorWait, writeMessage } from '../helpers/base';
import { KeydownListener } from '../helpers/keydown_listener';

const formElement = document.getElementById('form_forgot');
const messageElement = document.getElementById('message');

function initEventListeners() {
	const btnReset = document.getElementById('btn_reset');

	if (!btnReset) {
		console.error('Element btn_reset does not exist.');
		return;
	}

	btnReset.addEventListener('click', (e) => {
		e.preventDefault();
		submitForm();
	});
}

function setKeyPress() {
	const keyListener = new KeydownListener();

	// Adds listener.
	keyListener.toggle(submitForm);
}

async function submitForm() {
	const formData = new FormData(formElement);

	// Convert to URL-encoded string
	const formBody = new URLSearchParams(formData).toString();

	try {
		setCursorWait();

		const response = await fetch(`${window.rest_object.url}forgot`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': window.rest_object.nonce,
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: formBody,
			cache: 'no-cache'
		});

		const result = await response.json();

		clearErrors(formElement);

		const { message, status } = result;

		if (response.ok) {
			if (status === 'success') {
				document.getElementById('div_reset').style.display = 'block';
				document.getElementById('form_forgot').style.display = 'none';
			} else {
				document.getElementById('div_reset').style.display = 'none';
				document.getElementById('form_forgot').style.display = 'block';
			}

			writeMessage(messageElement, message, status);
		} else {
			const { errors } = result;

			if (errors && typeof errors === 'object') {
				addErrors(formElement, errors);
			}

			writeMessage(messageElement, message, 'error');
		}
	} catch (error) {
		const { message } = error;

		writeMessage(messageElement, message, 'error');
	} finally {
		clearCursorWait();
	}
}

document.addEventListener('DOMContentLoaded', function() {
	setKeyPress();
	initEventListeners();
});
